// extracted by mini-css-extract-plugin
module.exports = {"aboutContentWrapper":"About_aboutContentWrapper__eQkLE","aboutContent":"About_aboutContent__dcOH2"};